var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenuSearchLight = function SvgMenuSearchLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.536 10.024a6.318 6.318 0 1 0-1.382 1.457l3.186 3.627a1 1 0 1 0 1.502-1.32l-3.306-3.764Zm-.9-3.565a4.318 4.318 0 1 1-8.636 0 4.318 4.318 0 0 1 8.637 0Z",
    fill: "#fff"
  })));
};
export default SvgMenuSearchLight;